import { Injectable } from '@angular/core';
import { ProductGroupReferences } from '@product/const';
import { GroupReferencesFacade } from '@product/data-access';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GroupReferencesService {
  activeGroup$ = new ReplaySubject<string>(1);

  constructor(private groupReferencesFacade: GroupReferencesFacade) {}

  setActiveGroup(categoryCode: string): void {
    this.activeGroup$.next(categoryCode);
  }

  getActiveGroup(): Observable<string> {
    return this.activeGroup$.asObservable().pipe(distinctUntilChanged());
  }

  loadGroupReferences(productCode: string, referenceType: string): void {
    this.groupReferencesFacade.loadGroupReferences(productCode, referenceType);
  }

  getGroupReferences(productCode: string, referenceType: string): Observable<ProductGroupReferences[]> {
    return this.groupReferencesFacade.getGroupReferences(productCode, referenceType);
  }

  getGroupReferencesLoading(productCode: string, referenceType: string): Observable<boolean> {
    return this.groupReferencesFacade.getGroupReferencesLoading(productCode, referenceType);
  }

  getGroupReferencesSuccess(productCode: string, referenceType: string): Observable<boolean> {
    return this.groupReferencesFacade.getGroupReferencesSuccess(productCode, referenceType);
  }

  getGroupReferencesError(productCode: string, referenceType: string): Observable<boolean> {
    return this.groupReferencesFacade.getGroupReferencesError(productCode, referenceType);
  }

  resetGroupReferences(): void {
    this.groupReferencesFacade.resetGroupReferences();
  }
}
